export class WorkerFileDto {
  WorkerId: number;
  WorkerFileId: number;
  OriginalName: string;
  FileContent: any;
  WorkerFileTypeId: number;
  Description: null;
}
